import React, { Fragment } from 'react'
import { useIntl } from 'react-intl'
import Step from './Step/Step'
import './StepBar.scss'
import { getNewActivitySectionIcon, getNewActivitySectionIconColor } from '@/app/utils/newActivitySectionIcon'

const StepBar = (props) => {
    const componentClass = 'smart-modals-new-activity-step-bar'
    const intl = useIntl()

    return (
        <div className={componentClass}>
            <div className={`${componentClass}__title`}>
                {intl.formatMessage({
                    id: 'modals.new.activity.step.bar',
                    defaultMessage: 'Steps',
                })}
            </div>
            {props.stepList.map((step, index) => (
                <Fragment key={index}>
                    <div className={`${componentClass}__item`}>
                        <Step
                            icon={getNewActivitySectionIcon(step)}
                            color={getNewActivitySectionIconColor(step)}
                            step={intl.formatMessage({
                                id: step.label,
                                defaultMessage: step.key
                            })}
                        />
                    </div>
                    {index < props.stepList.length - 1 && <div className={`${componentClass}__bridge`}>
                        <div />
                    </div>}
                </Fragment>
            ))}
        </div>
    )
}

export default StepBar
